<template>
  <div id="keyboardPart">
    <div class="head">
      <div v-show="!enterStatus" class="title">{{$t('我的键盘')}}</div>
      <headNav v-show="connected&&enterStatus"></headNav>
    </div>
    <div v-show="!enterStatus" class="connectBox animate__animated animate__fadeIn">
      <div v-wave class="link" @click="toggleHIDConnection(false)"><i class="el-icon-link"></i>{{$t('授权并连接设备')}}</div>
    </div>
    <div v-show="!enterStatus" class="content animate__animated animate__fadeIn">
        <div class="keyboardBox_out" v-for="item in deviceList" :key="item.id">
          <div class="keyboardBox">
            <p class="keyboardName">{{ item.hidDev.productName }}</p>
            <div class="keyboardImg">
              <p class="keyboardImgIn" style="width: 3.4rem;height: 1.5rem">
                <img :src="getImgSrc(item.hidDev.productId)" :alt="item.hidDev.productName">
              </p>
            </div>
            <div v-wave class="keyboardStatus" @click="enterKeyboard(item.hidDev.productId)">
              <p>
                <span>{{$t('进入键盘')}}</span><img src="../assets/img/right.png" alt="" style="margin-left: 0.05rem;width: 0.15rem;height: 0.15rem">
              </p>
            </div>
          </div>
        </div>
      </div>
<!--    键盘区域-->
    <div v-show="connected&&enterStatus" class="centralRegion">
      <div class="keyBoxs_border">
        <div class="keyBoxs">
          <div class="keyBoxOut" v-for="(item, index) in key_name" :key="index"
               :class="[getKeyClass(index),getKeyClass_int(index)]"
               @click="keyClick(index, status[index])"
               @contextmenu.prevent="handleRightClick(index, status[index])"
          >
            <div class="selectOut" :class="[status[index] ? 'selected' : '']">
              <div class="keyBox">
                <div class="keyBoxIn">
                  <!--按键映射值-->
                  <p class="animate__animated animate__fadeIn" v-show="tabNum === 0 || tabNum === 4">{{KeyStrings[item]}}</p>
                  <p class="recoverBox animate__animated animate__fadeIn" v-show="tabNum === 0 && rearCoverList[index] !== 1000">S</p>
                  <p class="cover animate__animated animate__fadeIn" v-show="tabNum === 4 && RearCoverStatus === '0'">{{KeyStrings[rearCoverList[index]]}}</p>
                  <div class="groups animate__animated animate__fadeIn" v-show="tabNum === 4 && RearCoverStatus !== '0'">
                    <p class="group" v-show="bindKeyModeList[index] === 1">
                      MK
                    </p>
                    <p class="group" v-show="bindKeyModeList[index] === 2">
                      DKS
                    </p>
                  </div>
                  <div v-show="tabNum === 1" class="modeBox animate__animated animate__fadeIn">
<!--                    <i class="close-circle animate__animated animate__fadeIn el-icon-circle-close iconBottom" v-show="(!journeyIsCorrect(keyBodyList[index],keyPressList[index]) || !journeyIsCorrect(keyBodyList[index],keyNormPressList[index]))"/>-->
                    <div v-show="keyModeList[index] === 0 && ['0','1'].includes(functionMenu)">
                      <p :class="!journeyIsCorrect(keyBodyList[index],keyNormPressList[index]) ? 'warn' : ''">{{(keyNormPressList[index]/1000).toFixed(2)}}</p>
                      <p>{{(keyNormReturnList[index]/1000).toFixed(2)}}</p>
                    </div>
                    <div v-show="keyModeList[index] === 1 && ['0','1'].includes(functionMenu)" class="fastBox animate__animated animate__fadeIn">
                      <!--快速触发图标-->
                      <p><img src="../assets/img/lightning.png" alt="" style="width: 0.2rem;height: 0.2rem"></p>
                      <div class="fast">
                        <p :class="!journeyIsCorrect(keyBodyList[index],keyPressList[index]) ? 'warn' : ''">{{(keyPressList[index]/1000).toFixed(3)}}</p>
                        <p>{{(keyReturnList[index]/1000).toFixed(3)}}</p>
                        <p>{{(keyPressDeadzoneList[index]/1000).toFixed(3)}}</p>
                        <p>{{(keyReturnDeadzoneList[index]/1000).toFixed(3)}}</p>
                      </div>
                    </div>
                    <div v-show="functionMenu === '2'" class="keyBody animate__animated animate__fadeIn">
                      <p v-show="keyBodyList[index] === 0" class="bodyBox bgc3">{{$t('万磁王')}}</p>
                      <p v-show="keyBodyList[index] === 1" class="bodyBox bgc1">{{$t('万磁王(新)')}}</p>
                      <p v-show="keyBodyList[index] === 2" class="bodyBox bgc2">{{$t('磁玉pro')}}</p>
<!--                      <p v-show="keyBodyList[index] === 3" class="bodyBox bgc">封底磁珀</p>-->
                    </div>
                  </div>
                  <div v-show="tabNum === 2" class="modeBox animate__animated animate__fadeIn">
                    <p v-show="RgbModeListCopy[index] === 1" :style="{ background: rgbList[index] }" class="rgbBox">S</p>
                    <p v-show="RgbModeListCopy[index] === 0" class="rgbBox">D</p>
                  </div>
                  <div v-show="tabNum === 3 && displayData" class="modeBox animate__animated animate__fadeIn">
                    <p>{{ KeyValues[index] >> 4}}</p>
                    <p v-show="!calStatus">{{ formatNumber(KeyHeights[index],keyBodyList[index]) }}</p>
                    <p class="press" v-show="calStatus">{{ max[index] >> 4 }}</p>
                    <p class="press" v-show="calStatus">{{ min[index] >> 4 }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    按键区域-->
    <div v-show="connected&&enterStatus" class="layerBox animate__animated animate__fadeIn">
      <div class="layerBoxItem animate__animated animate__fadeIn" v-show="funPartCom === 'keysComponent'">
        <p v-wave class="layer" v-for="item in layerBoxList" :key="item.value" :class="item.status ? 'layerActive' : '' " @click="layerChange(item)">{{$t(item.name)}}</p>
        <p style="margin-left: 0.1rem" v-show="layerBoxList[1].status" class="animate__animated animate__fadeIn">
          <el-popover
            placement="right"
            :title="$t('提示内容66')"
            width="350"
            trigger="hover">
            <div>
              <p style="line-height: 0.25rem">
                {{$t('提示内容67')}}
              </p>
              <p style="line-height: 0.25rem">
                {{$t('提示内容68')}}
              </p>
              <p style="line-height: 0.25rem">
                {{$t('提示内容69')}}
              </p>
              <p style="line-height: 0.25rem">
                {{$t('提示内容70')}}
              </p>
              <p style="line-height: 0.25rem">
                {{$t('提示内容71')}}
              </p>
              <p style="line-height: 0.25rem">
                {{$t('提示内容72')}}
              </p>
              <p style="line-height: 0.25rem">
                {{$t('提示内容73')}}
              </p>
              <p style="line-height: 0.25rem">
                {{$t('提示内容74')}}
              </p>
              <p style="line-height: 0.25rem">
                {{$t('提示内容75')}}
              </p>
              <p style="line-height: 0.25rem">
                {{$t('提示内容76')}}
              </p>
            </div>
            <i slot="reference" class="el-icon-info" style="color: #FF9A00;font-size: 0.2rem;"></i>
          </el-popover>
        </p>
      </div>
      <div class="layerBoxItem animate__animated animate__fadeIn" v-show="['performanceSetting','lightingSetting'].includes(funPartCom)">
        <el-button v-wave type="primary" :disabled="Saving" :loading="confirmLoading" @click="confirm">{{$t('确认修改')}}</el-button>
      </div>
      <div class="layerBoxItem right">
        <p class="buttonBox">
          <el-tooltip class="item" effect="dark" :content="$t('保存至键盘')" placement="bottom">
            <el-button class="helpButton" v-wave type="primary" icon="el-icon-upload2" @click="handleToSave">{{ $t('保存') }}</el-button>
          </el-tooltip>
        </p>
        <p class="buttonBox">
          <el-tooltip class="item" effect="dark" :content="$t('重置当前配置')" placement="bottom">
            <el-button class="helpButton" v-wave type="primary" icon="el-icon-brush" @click="handleToResetConfig">{{ $t('重置') }}</el-button>
          </el-tooltip>
        </p>
        <p class="buttonBox">
          <el-tooltip class="item" effect="dark" :content="$t('重启键盘')" placement="bottom">
            <el-button class="helpButton" v-wave type="primary" icon="el-icon-refresh" @click="handleToReset">{{ $t('重启') }}</el-button>
          </el-tooltip>
        </p>
      </div>
    </div>
<!--    功能区域-->
    <div v-show="connected&&enterStatus" class="funPart animate__animated animate__fadeIn">
      <keysComponent v-show="funPartCom === 'keysComponent'" @set="HidCmdSetRam"></keysComponent>
      <performanceSetting v-show="funPartCom === 'performanceSetting'" @set="HidCmdSetRam"></performanceSetting>
      <lighting-setting v-show="funPartCom === 'lightingSetting'" @set="HidCmdSetRam" :HidCmdReadRam="HidCmdReadRam"></lighting-setting>
      <calibrateComponent v-show="funPartCom === 'calibrateComponent'" @set="HidCmdSetRam" @calib="HidCmdCalib"></calibrateComponent>
      <advancedKeysComponent v-show="funPartCom === 'advancedKeysComponent'" @set="HidCmdSetRam" @calib="HidCmdCalib"></advancedKeysComponent>
    </div>
    <el-dialog
      :title="$t('提示')"
      :visible.sync="tipsVisible"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center>
      <div style="height: 6.2rem">
        <el-carousel :interval="4000" arrow="always" height="5.8rem" indicator-position="outside">
          <el-carousel-item>
            <p style="display: flex;justify-content: center">
              <img src="../assets/img/tips2.png" alt="" style="width: 9rem;height: 4.5rem">
            </p>
          </el-carousel-item>
          <el-carousel-item>
            <p style="display: flex;justify-content: center">
              <img src="../assets/img/tips.png" alt="" style="width: 9rem;height: 5.62rem">
            </p>
          </el-carousel-item>
        </el-carousel>
        <p style="text-align: -webkit-center;font-size: 0.15rem;margin-top: 0.2rem">
          {{$t('提示内容77')}}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipsVisible = false">{{$t('确定')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  calibrationStatus75_zent,
  colorCodes75_zent,
  key_body75_zent,
  key_cover_zent,
  key_direction75_zent,
  key_heights75_zent,
  key_mode75_zent,
  key_name75_zent,
  key_norm_press_th75_zent,
  key_norm_return_th75_zent,
  key_press75_zent,
  key_press_deadzone75_zent,
  key_return75_zent,
  key_return_deadzone75_zent,
  key_status75_zent,
  key_values75_zent,
  key_zent75_address,
  bind_key_mode75_zent,
  KeyCodes,
  KeyStrings,
  max75_zent,
  min75_zent
} from '@/store/state'
import headNav from '../components/headNav.vue'
import keysComponent from '../components/keysComponent.vue'
import performanceSetting from '../components/performanceSetting.vue'
import lightingSetting from '../components/lightingSetting.vue'
import calibrateComponent from '../components/calibrateComponent.vue'
import advancedKeysComponent from "@/components/advancedKeysComponent.vue";
import EventBus from '@/store/eventBus'
import {
  arraysAreEqual,
  arrayToUint16StringArray,
  convertToArrayWithHighLowDigits,
  convertToBase10,
  convertUint8ArrayToChinese,
  delay,
  reverseConvert,
  stringToUint8Array
} from "@/store/utils";
import Queue from '../store/queue'
import CRC16_Modbus from '../store/crc'

export default {
  name: "keyboardPart",
  components: {
    headNav,
    keysComponent,
    performanceSetting,
    lightingSetting,
    calibrateComponent,
    advancedKeysComponent
  },
  watch: {
    'hid_send_buffer.items': {
      deep: true,
      handler() {
        this.sendHIDData()
      }
    },
    tabNum(newValue) {
      if (newValue === 3) {
        this.startHeartbeat()
      } else {
        this.stopHeartbeat()
      }
    },
    calStatus(newValue) {
      this.isAgreeSave = !newValue
    },
    atLeastOne(newValue) {
      if (newValue) {
        EventBus.$emit('permitClick',newValue)
      }
    },
  },
  computed: {
    // 根据配列和层返回key数组
    key_name() {
      let arr = []
      if (this.isFnLayer ==='0') {
        arr =  this.keyNameList[0]
      } else if(this.isFnLayer === '1') {
        arr =  this.keyNameList[1]
      }
      return arr
    },
    status() {
      return this.keyStatusList[this.tabNum]
    }
  },
  data() {
    return {
      firstJoin: false, // 是否第一次授权连接设备
      tipsVisible: false, // 是否显示固定按键提示弹框
      tabNum: 0, // 默认按键映射
      layerBoxList: [
        {
          name: '主层',
          value: '0',
          status: true
        },
        {
          name: 'Fn层',
          value: '1',
          status: false
        }
      ], // 层级数组
      keyStatusList: key_status75_zent, // 默认75配列
      keyNameList: key_name75_zent,  // 默认75配列
      rearCoverList: key_cover_zent, // 默认75配列
      addressList: key_zent75_address, // 默认75配列
      keyboardLength: 83, // 默认75配列
      keyModeList: key_mode75_zent, // 默认75配列
      keyBodyList: key_body75_zent, // 默认75配列
      keyPressList: key_press75_zent, // 默认75配列
      keyReturnList: key_return75_zent, // 默认75配列
      keyNormPressList: key_norm_press_th75_zent, // 默认75配列
      keyNormReturnList: key_norm_return_th75_zent, // 默认75配列
      keyPressDeadzoneList: key_press_deadzone75_zent, // 默认75配列
      keyReturnDeadzoneList: key_return_deadzone75_zent, // 默认75配列
      KeyValues: key_values75_zent, // 默认75配列
      KeyHeights: key_heights75_zent, // 默认75配列
      KeyDirection: key_direction75_zent, // 默认75配列
      calibrationStatus: calibrationStatus75_zent, // 默认75配列
      bindKeyModeList: bind_key_mode75_zent, // 默认75配列
      checkedList: [], // 性能页面已选择的按键
      checkedListColor: [], // rgb页面已选择的按键
      KeyStrings: KeyStrings,
      enterStatus: false, // 是否进入键盘
      funPartCom: 'keysComponent',
      isFnLayer: '0', //
      connected: false, // 键盘连接状态
      hid_send_buffer: new Queue(),
      device: {}, // 设备信息对象
      deviceList: [], // 设备列表
      // 需要导出的灯光配置
      dataToExport: [],
      deviceImgList:[
        {
          productId: 13694,
          src: require('@/assets/img/product.png')
        }
      ],
      intervalId: null, // 心跳包定时器
      productName: '', // 设备名称
      hidData: '',
      serialNumber: [],// 设备序列号
      ack_buffer: new Uint8Array(0),
      sent_state: false,
      sent_ack: false,
      receive_monitor_task: null,
      receive_monitor: 0,
      receive_monitor_cnt: 0,
      readErrorNum: 0,
      disposition: null, // 当前配置
      dispositionCopy: null,
      keyObj: {}, // 性能设置页面各个参数的当前值
      functionMenu: '0', // 性能页面当前菜单
      confirmLoading: false, // 确认按钮是否在加载
      submit_result: '0',
      submit_result1: '0',
      submit_result2: '0',
      submit_result3: '0',
      submit_result4: '0',
      submit_result5: '0',
      submit_result6: '0',
      submit_result7: '0',
      keyBodyValue: 1, // 默认为万磁王(新)
      isAgreeSave: true, // 用于判断校准时是否允许保存
      Saving: false, // 用于判断保存过程中是否允许点击确认修改
      calStatus: false, // 是否开始标定
      maxCopy: [],
      minCopy: [],
      max: max75_zent,
      min: min75_zent,
      flag: 0,
      times: 0,
      configtimes: 0,
      atLeastOne: false, // 是否有按键完成了标定
      testMode: '0', // 默认在校准tab
      testKey: null, // 试轴器选中的按键
      keyColorList: [], //Rgb
      RgbModeList: [],// RGB模式
      RgbModeListCopy: [],
      rgbList: [],
      firmwareVersion: '', // 固件版本号
      version: 0, // 固件版本
      displayData: true, // 是否显示校准页面的按键数据
      RearCoverStatus: '0', // 0代表后覆盖 '1'代表组合键 '2'代表DKS
    }
  },
  beforeDestroy() {
    // 移除事件监听器
    navigator.hid.removeEventListener('connect', this.handleDeviceConnected);
    window.removeEventListener("keydown", this.disableKeys);
  },
  mounted() {
    // 设置连接的监听
    navigator.hid.addEventListener('connect', this.handleDeviceConnected);
    this.autoConnectDevice()
    EventBus.$on('navActiveChange',this.handleNavActiveChange)
    EventBus.$on('quitKeyboard',this.handleQuitKeyboard)
    EventBus.$on('changeKey', this.handleChangeKey)
    EventBus.$on('fastSelect', this.handleFastSelect)
    EventBus.$on('settingTabChange',this.handleSettingTabChange)
    EventBus.$on('sliderChange',this.handleSliderChange)
    EventBus.$on('selectKeyBody',this.handleSelectKeyBody)
    EventBus.$on('startCal',this.handleStartCal)
    EventBus.$on('stopCal',this.handleStopCal)
    EventBus.$on('finishSubmit',this.handleFinishSubmit)
    EventBus.$on('calTabChange',this.handleCalTabChange)
    EventBus.$on('lightingSettingReturn',this.handleLightingSettingReturn)
    EventBus.$on('getSettingPartData',this.handleGetSettingPartData)
    EventBus.$on('finishName',this.handleFinishName)
    EventBus.$on('changeConfig',this.handleChangeConfig)
    EventBus.$on('displayData',this.handleDisplayData)
    EventBus.$on('downloadMode',this.handleDownloadMode)
    EventBus.$on('exportToJson',this.handleExportToJson)
    EventBus.$on('getKeyRGBDate',this.getKeyRGBDate)
    EventBus.$on('autoCalibSave',this.HidCmdSave)
    EventBus.$on('advancedKeysComTab',this.handleAdvancedKeysComTab)
    EventBus.$on('groupKeysConfirm',this.handleGroupKeysConfirm)
    EventBus.$on('DKSKeysConfirm',this.handleDKSKeysConfirm)



    // 监听浏览器页面的可见性变化
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    // 初次加载时开启watch监听器
    this.startWatch();
  },
  methods: {
    async handleDKSKeysConfirm(data) {
      const {key, list} = data
      this.$set(this.bindKeyModeList, key, 2)
      let address = '0x' + (Number(this.addressList.bind_key_setting.address) + key * 48).toString(16)
      await this.HidCmdSetRam(this.addressList.bind_key_mode.address, this.bindKeyModeList, this.addressList.bind_key_mode.length)
      await delay()
      await this.HidCmdSetRam(address, list, list.length)
      await this.keyClick(key, this.status[key])
    },
    async handleGroupKeysConfirm(data) {
      const {key, group, cover} = data
      this.$set(this.bindKeyModeList, key, 1)
      let arr = []
      group.forEach(e => {
        arr.push(e.value)
      })
      let ram = convertToArrayWithHighLowDigits(arr)
      let address = '0x' + (Number(this.addressList.bind_key_setting.address) + key * 48 + 16).toString(16)
      let address1 = '0x' + (Number(this.addressList.bind_key_setting.address) + key * 48 + 47).toString(16)
      await this.HidCmdSetRam(this.addressList.bind_key_mode.address, this.bindKeyModeList, this.addressList.bind_key_mode.length)
      await delay()
      await this.HidCmdSetRam(address, ram, ram.length)
      await delay()
      await this.HidCmdSetRam(address1, [cover], 1)
      await this.keyClick(key, this.status[key])
    },
    // 监听高级按键类别的回调
    handleAdvancedKeysComTab(val) {
      this.RearCoverStatus = val
    },
    getKeyClass(i) {
      let result = ''
      if (this.keyboardLength === 83) {
        switch (i) {
          case 28:
            result = 'keyBig1'
            break;
          case 30:
          case 43:
            result = 'keyBig2'
            break;
          case 45:
          case 70:
            result = 'keyBig3'
            break;
          case 57:
          case 59:
            result = 'keyBig4'
            break;
          case 73:
          case 74:
          case 75:
            result = 'keyBig5'
            break;
          case 76:
            result = 'keyBig6'
            break;
        }
      }
      return result
    },
    getKeyClass_int(i) {
      let result = ''
      if (this.keyboardLength === 83) {
        switch (i) {
          case 0:
          case 4:
          case 8:
          case 12:
            result = 'interval1'
            break;
          case 1:
          case 2:
          case 3:
          case 5:
          case 6:
          case 7:
          case 9:
          case 10:
          case 11:
          case 13:
          case 14:
            result = 'interval4'
            break;
        }
      }
      return result
    },
    handleDeviceConnected() {
      this.autoConnectDevice()
    },
    getImgSrc(id) {
      let src = ''
      this.deviceImgList.forEach(e => {
        if (e.productId === id) {
          src = e.src
        }
      })
      return src
    },
    startWatch() {
      // 开始watch监听器
      this.unwatch = this.$watch('disposition', async (newValue, oldValue) => {
        if (newValue !== oldValue && oldValue !== null) {
          EventBus.$emit('loading', {
            loading: true,
            loadingMsg: '配置切换中...'
          })
          await this.getConfigData(false, newValue)
        }
      }); // 300毫秒的防抖时间，可以根据需要调整
    },
    stopWatch() {
      // 解除watch监听器
      if (this.unwatch) {
        this.unwatch();
        this.unwatch = null;
      }
    },
    async handleDownloadMode() {
      EventBus.$emit('getIsReload', false)
      await this.HidCmdDownload()
    },
    handleDisplayData(val) {
      this.displayData = val
    },
    async handleVisibilityChange() {
      if (this.connected) {
        if (document.hidden) {
          // 用户离开页面时解除watch监听器
          this.dispositionCopy = this.disposition
          this.stopWatch();
        } else {
          // 用户回到页面时重新开启watch监听器
          this.startWatch();
          await delay()
          await this.getConfigData(false, null,true)
        }
      }
    },
    async getConfigData(flag,val,inflag) {
      await delay(200)
      await this.HidCmdReadRam(this.addressList.cur_param_num.address, this.addressList.cur_param_num.length).then(async res => {
        if (inflag && res[0] !== this.dispositionCopy) {
          EventBus.$emit('loading', {
            loading: true,
            loadingMsg: '配置加载中...'
          })
        }
        if (!flag) {
          if (res.length !== 0) {
            if (res[0] === val || inflag) {
              if (res[0] !== this.dispositionCopy) {
                EventBus.$emit('activeConfig',res[0])
                this.configtimes = 0
                // await delay(200)
                await this.getAllData()
                this.dispositionCopy = null
              }
            } else {
              await this.HidCmdSwitchConfig(val)
            }
          } else {
            this.configtimes++
            if (this.configtimes < 11) {
              await delay(300)
              await this.getConfigData(false, val)
            } else {
              this.$notify.error({
                title: this.$t('错误'),
                message: this.$t('提示内容38'),
                offset: 100
              })
              EventBus.$emit('loading', {
                loading: false,
                loadingMsg: ''
              })
              this.configtimes = 0
              return
            }
          }
        } else {
          EventBus.$emit('activeConfig',res[0])
          this.disposition = res[0]  // 初始化
        }
      })
    },
    // 处理导出灯光回调
    async handleExportToJson() {
      // 按键rgb值
      const rgb_matrix_settings1 = await this.HidCmdReadRam(this.addressList.rgb.address,this.addressList.rgb.length)
      // 按键rgb模式
      const rgb_matrix_settings2 = await this.HidCmdReadRam(this.addressList.rgb_solid_enable.address,this.addressList.rgb_solid_enable.length)
      // 灯光设置
      const rgb_config_settings = await this.HidCmdReadRam(this.addressList.rgb_config.address,17)

      let rgb_matrix_settings = [...rgb_matrix_settings1,...rgb_matrix_settings2]
      this.dataToExport = [
        {
          name: this.productName,
          length: 0,
          value: []
        },
        {
          name: 'rgb_matrix_settings',
          length: rgb_matrix_settings.length,
          value: rgb_matrix_settings
        },
        {
          name: 'rgb_config_settings',
          length: rgb_config_settings.length,
          value: rgb_config_settings
        }
      ]
      const dataStr = JSON.stringify(this.dataToExport);
      const blob = new Blob([dataStr], {type: 'application/json'});
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'rgb_config.json';
      a.click();
      URL.revokeObjectURL(url);

      this.$notify({
        title: this.$t('成功'),
        message: this.$t('提示内容39'),
        type: 'success',
        offset: 100
      })
    },
    formatNumber(value,body) {
      if (body === 0) {
        if (parseFloat(value) > 3.417) {
          return 60
        } else {
          return Math.ceil(parseFloat(value) / 0.058)
        }
      } else if(body === 1) {
        if (parseFloat(value) > 3.372) {
          return 60
        } else {
          return Math.ceil(parseFloat(value) / 0.0572)
        }
      } else {
        if (parseFloat(value) > 3.417) {
          return 60
        } else {
          return Math.ceil(parseFloat(value) / 0.058)
        }
      }
    },
    // 点击进入键盘根据选中的hid设备赋值给全局的device对象
    async enterKeyboard(id) {
      // this.enterStatus = true
      // 根据选择的hid设备
      this.deviceList.forEach(e => {
        if (e.hidDev.productId === id) {
          this.device = e.hidDev
        }
      })
      if (this.device) {
        this.productName = this.device.productName
        EventBus.$emit('getProductName', this.productName)
        //根据配列赋值长度
        if(this.device.productId === 13694) {
          // zent75重新从初始化
          this.keyboardLength = 83
          this.addressList = key_zent75_address
          this.keyStatusList = key_status75_zent
          this.keyNameList = key_name75_zent
          this.rearCoverList = key_cover_zent
          this.keyModeList = key_mode75_zent
          this.keyBodyList = key_body75_zent
          this.keyPressList = key_press75_zent
          this.bindKeyModeList = bind_key_mode75_zent
          this.keyReturnList = key_return75_zent
          this.keyNormPressList = key_norm_press_th75_zent
          this.keyNormReturnList = key_norm_return_th75_zent
          this.keyPressDeadzoneList = key_press_deadzone75_zent
          this.keyReturnDeadzoneList = key_return_deadzone75_zent
          this.KeyValues = key_values75_zent
          this.KeyHeights = key_heights75_zent
          this.KeyDirection = key_direction75_zent
          this.max = max75_zent
          this.min = min75_zent
          this.calibrationStatus = calibrationStatus75_zent
        }
        await this.device.open();
        // Set up event listener for data reports
        this.inputReportListener = (event) => {
          this.handleHIDData(new Uint8Array(event.data.buffer));
        };
        this.device.addEventListener("inputreport", this.inputReportListener);

        this.hid_send_buffer.clear();
        this.connected = true;
        await this.getConfigData(true)
        await delay()
        await this.getAllData()
        EventBus.$emit('connected', true)
        EventBus.$emit('getInitializeResult', {
          addressList: this.addressList,
          keyboardLength: this.keyboardLength,
          productId: this.device.productId
        })
      }
      this.enterStatus = true
      // 第一次授权连接设备显示提示弹框
      if (this.enterStatus && this.firstJoin) {
        this.tipsVisible = true
      }
      EventBus.$emit('enterKeyboard',{
        productId: this.device.productId
      })
    },
    async handleChangeConfig(data) {
      await this.HidCmdSwitchConfig(data.value)
    },
    async handleFinishName(item) {
      // if (item.name.length > 10) {
      //   this.$notify({
      //     title: this.$t('警告'),
      //     message: this.$t('提示内容40'),
      //     type: 'warning',
      //     offset: 100
      //   })
      // } else if (item.name === '') {
      //   this.$notify({
      //     title: this.$t('警告'),
      //     message: this.$t('提示内容41'),
      //     type: 'warning',
      //     offset: 100
      //   })
      // } else {
        let configName = item.name
        const uint8Array = stringToUint8Array(configName)
        const uint8ArrayLength = uint8Array.length
        let arr = Array((64 - uint8ArrayLength)).fill(0)
        const combinedArray = [];
        for (const value of uint8Array) {
          combinedArray.push(value);
        }
        combinedArray.push(...arr)
        let chineseString = []
        let address = ('0x' + (Number(this.addressList.config_name1.address) + item.value * 64).toString(16))
        await this.HidCmdSetRam(address, combinedArray, 64)
        await delay()
        chineseString = await this.HidCmdReadRam(address, 64)
        EventBus.$emit('returnConfigName',{
          value: item.value,
          name: convertUint8ArrayToChinese(chineseString.slice(0, uint8ArrayLength))
        })
      // }
    },
    handleGetSettingPartData() {
      this.HidCmdSerialNumber()
    },
    async handleLightingSettingReturn(obj) {
      if (obj.tabActive === '1') { // tab在静态
        if (this.keyStatusList[2].includes(true)) {
          this.keyColorList = await this.HidCmdReadRam(this.addressList.rgb.address, this.addressList.rgb.length)
          this.RgbModeList = await this.HidCmdReadRam(this.addressList.rgb_solid_enable.address, this.addressList.rgb_solid_enable.length)

          let colorList = []
          let rgbNumbers = [obj.color.r, obj.color.g, obj.color.b]
          for (let i = 0; i < this.keyColorList.length; i = i + 3) {
            let list = [this.keyColorList[i], this.keyColorList[i + 1], this.keyColorList[i + 2]]
            colorList.push(list)
          }
          if(this.keyboardLength === 83) {
            for (let i = 0; i < this.keyboardLength; i++) {
              if (this.keyStatusList[2][i]) {
                if (i === 76) {
                  for (let j = 0; j < 3; j++) {
                    let num1 = colorCodes75_zent[i][j]
                    colorList[num1] = rgbNumbers
                    this.RgbModeList[num1] = Number(obj.tabActive)
                  }
                } else {
                  let num = colorCodes75_zent[i]
                  colorList[num] = rgbNumbers
                  this.RgbModeList[num] = Number(obj.tabActive)
                }
              }
            }
          }


          let list = [].concat(...colorList)
          // list = list.concat(...this.RgbModeList)
          let int8Array = list.map(num => {
            // 将数值限制在 0 到 255 范围内
            return Math.min(255, Math.max(0, num));
          })
          await this.HidCmdSetRam(this.addressList.rgb.address, int8Array, this.addressList.rgb.length)
          await delay()
          await this.HidCmdSetRam(this.addressList.rgb_solid_enable.address, this.RgbModeList, this.addressList.rgb_solid_enable.length)
          await delay()
          let rgbList = await this.HidCmdReadRam(this.addressList.rgb.address, this.addressList.rgb.length)
          let rgbModeList = await this.HidCmdReadRam(this.addressList.rgb_solid_enable.address, this.addressList.rgb_solid_enable.length)
          this.getKeyRGBDate([...rgbList,...rgbModeList])
        }
      } else {  // tab在动态
        let list = await this.HidCmdReadRam(this.addressList.rgb_solid_enable.address,this.addressList.rgb_solid_enable.length)
        if (this.keyboardLength === 83) {
          for (let i = 0; i < this.keyboardLength; i++) {
            if (this.keyStatusList[2][i]) {
              if (i === 76) {
                for (let j = 0; j < 3; j++) {
                  let num1 = colorCodes75_zent[i][j]
                  list[num1] = Number(obj.tabActive)
                }
              } else {
                let num = colorCodes75_zent[i]
                list[num] = Number(obj.tabActive)
              }
            }
          }
        }
        await Promise.all([this.HidCmdSetRam(this.addressList.rgb_solid_enable.address, list, this.addressList.rgb_solid_enable.length)])
        await delay()
        let rgbList = await this.HidCmdReadRam(this.addressList.rgb.address, this.addressList.rgb.length)
        let rgbModeList = await this.HidCmdReadRam(this.addressList.rgb_solid_enable.address, this.addressList.rgb_solid_enable.length)
        this.getKeyRGBDate([...rgbList,...rgbModeList])
      }
      let arr = [1 + obj.dynamicLightSetting.dynamicMode * 4, obj.dynamicLightSetting.H, obj.dynamicLightSetting.S, obj.jointLightSetting.luminance, obj.dynamicLightSetting.speed]
      await this.HidCmdSetRam(this.addressList.rgb_config.address, arr, this.addressList.rgb_config.length)
      await delay(1000)
      this.$notify({
        title: this.$t('成功'),
        message: this.$t('提示内容42'),
        type: 'success',
        offset: 100
      });
    },
    handleQuitKeyboard() {
      this.enterStatus = false
      this.toggleHIDConnection(true)
    },
    handleCalTabChange(val) {
      this.testMode = val
    },
    async handleFinishSubmit() {
      let arr = this.calibrationStatus.reduce((indices, value, index) => {
        if (value) {
          indices.push(index);
        }
        return indices;
      }, [])
      if (arr.length !== 0) {
        await this.HidCmdCalib(0)
        arr.forEach(item => {
          if (this.KeyDirection[item] === '0') { // 按下变大，顶部值为最小
            // 根据已经存在的校准数据更新顶部值
            this.maxCopy[item] = this.min[item]
            // 根据已经存在的校准数据更新底部值
            this.minCopy[item] = this.max[item]
          } else {
            this.maxCopy[item] = this.max[item]
            this.minCopy[item] = this.min[item]
          }
        })
        let set_data = new Uint8Array(this.keyboardLength*4)
        for (let i = 0; i < this.keyboardLength; i++) {
          set_data[i * 2] = this.maxCopy[i] % 256;
          set_data[i * 2 + 1] = this.maxCopy[i] / 256;
          set_data[i * 2 + (this.keyboardLength*2)] = this.minCopy[i] % 256;
          set_data[i * 2 + (this.keyboardLength*2 + 1)] = this.minCopy[i] / 256;
        }
        let list = set_data.slice(0,this.keyboardLength * 2)
        let list1 = set_data.slice(this.keyboardLength * 2,this.keyboardLength * 4)
        await delay()
        await this.HidCmdSetRam(this.addressList.top_value.address, list, list.length)
        await this.HidCmdSetRam(this.addressList.bot_value.address, list1, list1.length)
        this.$notify({
          title: this.$t('成功'),
          message: this.$t('提示内容43'),
          type: 'success',
          offset: 100
        });
        // 提交校准数据完成，初始化数据
        this.times = 0
        this.flag = 0
        this.maxCopy = []
        this.minCopy = []
        this.KeyDirection = Array(this.keyboardLength).fill('0')
        this.max = Array(this.keyboardLength).fill(0)
        this.min = Array(this.keyboardLength).fill(65535)
        this.calibrationStatus = Array(this.keyboardLength).fill(false)
        this.$set(this.keyStatusList, 3, Array(this.keyboardLength).fill(false))
        // this.$set(this,'status',Array(this.keyboardLength).fill(false))
        this.calStatus = false
        EventBus.$emit('sendFinish')
      } else {
        this.$notify.info({
          title: this.$t('消息'),
          message: this.$t('提示内容44'),
          offset: 100
        });
      }
    },
    async handleStopCal() {
      this.times = 0
      this.flag = 0
      this.maxCopy = []
      this.minCopy = []
      this.KeyDirection = Array(this.keyboardLength).fill('0')
      this.max = Array(this.keyboardLength).fill(0)
      this.min = Array(this.keyboardLength).fill(65535)
      this.calibrationStatus = Array(this.keyboardLength).fill(false)
      this.$set(this.keyStatusList, 3, Array(this.keyboardLength).fill(false))
      this.calStatus = false
    },
    async handleStartCal(val) {
      if (this.connected) {
        this.calStatus = val
        await this.HidCmdReadRam(this.addressList.top_value.address, this.addressList.top_value.length).then(async result => {
          this.maxCopy = reverseConvert(result) // 顶部值
          let result1 = await this.HidCmdReadRam(this.addressList.bot_value.address,this.addressList.bot_value.length)
          this.minCopy = reverseConvert(result1) // 底部值
        })
        await delay()
        await this.HidCmdCalib(1)
        this.$set(this.keyStatusList, 3, Array(this.keyboardLength).fill(false))
        // this.$set(this,'status',Array(this.keyboardLength).fill(false))
      }
    },
    handleToSave() {
      if (this.connected) {
        if (this.isAgreeSave) {
          this.Saving = true
          this.HidCmdSave()
        } else {
          this.$notify({
            title: this.$t('警告'),
            message: this.$t('提示内容45'),
            type: 'warning',
            offset: 100
          });
        }
      }
    },
    handleToReset() {
      if (this.connected) {
        this.$confirm(this.$t('提示内容46'), this.$t('提示'), {
          confirmButtonText: this.$t('确定'),
          cancelButtonText: this.$t('取消'),
          type: 'warning'
        }).then(() => {
          this.HidCmdReset()
        }).catch(() => {
          this.$notify.info({
            title: this.$t('消息'),
            message: this.$t('已取消'),
            offset: 100
          });
        });
      }
    },
    async handleToResetConfig() {
      if (this.connected) {
        EventBus.$emit('loading', {
          loading: true,
          loadingMsg: '配置重置中...'
        })
        this.HidCmdResetConfig()
        await delay(300)
        await this.getAllData()
      }
    },
    // 获取选择的轴体
    handleSelectKeyBody(value) {
      this.keyBodyValue = value
    },
    journeyIsCorrect(bodyVal,journeyVal) {
      let result = true
      switch (bodyVal) {
        case 0:
          if (journeyVal >= 3420) result = false // 万磁王轴
          break;
        case 1:
          if (journeyVal >= 3375) result = false // 新万磁王轴
          break;
        case 2:
          if (journeyVal >= 3420) result = false // 磁玉pro
          break;
        case 3:
          if (journeyVal >= 3780) result = false
          break;
      }
      return result
    },
    // 确认修改
    async confirm() {
      if (this.funPartCom === 'performanceSetting') { // 性能页面
        if (this.checkedList.length !== 0) {
          if (this.functionMenu === '2') { // 轴体
            if (this.connected) {
              this.$confirm(this.$t('提示内容47') +
                this.$t('提示内容48') +
                this.$t('提示内容49'), this.$t('提示'), {
                confirmButtonText: this.$t('确定'),
                cancelButtonText: this.$t('取消'),
                type: 'warning'
              }).then(async () => {
                if (this.checkedList.length !== 0) {
                  let temporaryArray = JSON.parse(JSON.stringify(this.keyBodyList));
                  for (let i = 0; i < this.checkedList.length; i++) {
                    temporaryArray[this.checkedList[i]] = this.keyBodyValue
                  }

                  if (new Set(temporaryArray).size > 4) {
                    this.$notify.info({
                      title: this.$t('提示'),
                      message: this.$t('提示内容50'),
                      offset: 100
                    });
                    return
                  } else {
                    this.keyBodyList = JSON.parse(JSON.stringify(temporaryArray))
                  }
                  this.confirmLoading = true
                  await this.submitKeyBody()
                  if (this.submit_result7 === '1') {
                    await delay(1000)
                    this.confirmLoading = false
                    this.$notify({
                      title: this.$t('成功'),
                      message: this.$t('修改成功'),
                      type: 'success',
                      offset: 100
                    });
                    this.submit_result7 = '0'
                    this.backDisplay()
                  } else {
                    this.confirmLoading = false
                    this.$notify.error({
                      title: this.$t('错误'),
                      message: this.$t('提示内容51'),
                      offset: 100
                    });
                  }
                } else {
                  this.$notify.info({
                    title: this.$t('消息'),
                    message: this.$t('提示内容52'),
                    offset: 100
                  });
                }
              }).catch(() => {})
            } else {
              this.$notify.info({
                title: this.$t('提示'),
                message: this.$t('提示内容1'),
                offset: 100
              })
            }
          } else { // 触发模式
            let arr = []
            for (let i = 0; i < this.checkedList.length; i++) {
              let bol1 = true
              let bol2 = true
              bol1 = this.journeyIsCorrect(this.keyBodyList[this.checkedList[i]],this.keyNormPressList[this.checkedList[i]])
              bol2 = this.journeyIsCorrect(this.keyBodyList[this.checkedList[i]],this.keyPressList[this.checkedList[i]])
              arr.push(bol1)
              arr.push(bol2)
            }
            if (arr.includes(false)) {
              this.$notify.info({
                title: this.$t('提示'),
                message: this.$t('提示内容53'),
                offset: 100
              })
            } else {
              if (this.connected) {
                this.confirmLoading = true
                await this.submitKeyMode()
                if (this.submit_result === '1') {
                  await this.submitNormalKeyValue()
                } else {
                  this.confirmLoading = false
                  this.$notify.error({
                    title: this.$t('错误'),
                    message: this.$t('提示内容51'),
                    offset: 100
                  });
                  return
                }
                if (this.submit_result1 === '1') {
                  await this.submitNormalKeyValue1()
                } else {
                  this.confirmLoading = false
                  this.$notify.error({
                    title: this.$t('错误'),
                    message: this.$t('提示内容51'),
                    offset: 100
                  });
                  return
                }
                if (this.submit_result2 === '1') {
                  await this.submitFastKeyValue()
                } else {
                  this.confirmLoading = false
                  this.$notify.error({
                    title: this.$t('错误'),
                    message: this.$t('提示内容51'),
                    offset: 100
                  });
                  return
                }
                if (this.submit_result3 === '1') {
                  await this.submitFastKeyValue1()
                } else {
                  this.confirmLoading = false
                  this.$notify.error({
                    title: this.$t('错误'),
                    message: this.$t('提示内容51'),
                    offset: 100
                  });
                  return
                }
                if (this.submit_result4 === '1') {
                  await this.submitFastKeyValue2()
                } else {
                  this.confirmLoading = false
                  this.$notify.error({
                    title: this.$t('错误'),
                    message: this.$t('提示内容51'),
                    offset: 100
                  });
                  return
                }
                if (this.submit_result5 === '1') {
                  await this.submitFastKeyValue3()
                } else {
                  this.confirmLoading = false
                  this.$notify.error({
                    title: this.$t('错误'),
                    message: this.$t('提示内容51'),
                    offset: 100
                  });
                  return
                }
                if (this.submit_result6 === '1') {
                  this.$notify({
                    title: this.$t('成功'),
                    message: this.$t('修改成功'),
                    type: 'success',
                    offset: 100
                  });
                  this.submit_result = '0'
                  this.submit_result1 = '0'
                  this.submit_result2 = '0'
                  this.submit_result3 = '0'
                  this.submit_result4 = '0'
                  this.submit_result5 = '0'
                  this.submit_result6 = '0'
                  this.confirmLoading = false
                } else {
                  this.confirmLoading = false
                  this.$notify.error({
                    title: this.$t('错误'),
                    message: this.$t('提示内容51'),
                    offset: 100
                  });
                  return
                }
              } else {
                this.$notify.info({
                  title: this.$t('消息'),
                  message: this.$t('提示内容1'),
                  offset: 100
                });
              }
            }
          }
        } else {
          this.$notify.info({
            title: this.$t('消息'),
            message: this.$t('提示内容52'),
            offset: 100
          });
        }
      } else if (this.funPartCom === 'lightingSetting') { // 灯光页面
        if (this.checkedListColor.length !== 0) {
          EventBus.$emit('lightingSettingConfirm')
        } else {
          this.$notify.info({
            title: this.$t('消息'),
            message: this.$t('提示内容52'),
            offset: 100
          });
        }
      }
    },
    // 发送并校验按键轴体的方法
    async submitKeyBody() {
      let times =  0
      await this.HidCmdSetRam(this.addressList.keytype_code.address, convertToArrayWithHighLowDigits(this.keyBodyList), this.addressList.keytype_code.length).then(async () => {
        await delay()
        await this.HidCmdReadRam(this.addressList.keytype_code.address, this.addressList.keytype_code.length).then(result => {
          let compareResult = arraysAreEqual(convertToBase10(result), this.keyBodyList)
          if (compareResult) {
            this.getKeyBodyTypeDate(result)
            this.submit_result7 = '1'
            return
          } else {
            times ++
            if (times < 3) {
              this.submitKeyBody()
            } else {
              this.submit_result7 = '2'
              return
            }
          }
        })
      })
    },
    // 发送并校验按键模式的方法
    async submitKeyMode() {
      let times =  0
      await this.HidCmdSetRam(this.addressList.key_mode.address, this.keyModeList, this.addressList.key_mode.length).then(async () => {
        await delay()
        await this.HidCmdReadRam(this.addressList.key_mode.address, this.addressList.key_mode.length).then(result => {
          let compareResult = arraysAreEqual(result, this.keyModeList)
          if (compareResult) {
            this.getKeyMode(result)
            this.submit_result = '1'
            return
          } else {
            times ++
            if (times < 3) {
              this.submitKeyMode()
            } else {
              this.submit_result = '2'
              return
            }
          }
        })
      })
    },
    // 发送并校验普通模式下按键触发值的方法
    async submitNormalKeyValue() {
      let times =  0
      let arr = convertToArrayWithHighLowDigits(this.keyPressList)
      await this.HidCmdSetRam(this.addressList.press_th.address, arr, this.addressList.press_th.length).then(async () => {
        await delay()
        let result = await this.HidCmdReadRam(this.addressList.press_th.address, this.addressList.press_th.length)
        let compareResult = arraysAreEqual(convertToBase10(result), this.keyPressList)
        if (compareResult) {
          this.getKeyPressDate(result)
          this.submit_result1 = '1'
          return
        } else {
          times++
          if (times < 3) {
            await this.submitNormalKeyValue()
          } else {
            this.submit_result1 = '2'
            return
          }
        }
      })
    },
    // 发送并校验普通模式下按键回弹值的方法
    async submitNormalKeyValue1() {
      let times =  0
      let arr = convertToArrayWithHighLowDigits(this.keyReturnList)
      await this.HidCmdSetRam(this.addressList.return_th.address, arr, this.addressList.return_th.length).then(async () => {
        await delay()
        let result = await this.HidCmdReadRam(this.addressList.return_th.address, this.addressList.return_th.length)
        let compareResult = arraysAreEqual(convertToBase10(result), this.keyReturnList)
        if (compareResult) {
          this.getKeyReturnDate(result)
          this.submit_result2 = '1'
          return
        } else {
          times++
          if (times < 3) {
            await this.submitNormalKeyValue1()
          } else {
            this.submit_result2 = '2'
            return
          }
        }
      })
    },
    // 发送并校验快速触发模式下按键触发距离的方法
    async submitFastKeyValue() {
      let times = 0
      let arr = convertToArrayWithHighLowDigits(this.keyNormPressList)
      await this.HidCmdSetRam(this.addressList.norm_press_th.address, arr, this.addressList.norm_press_th.length).then(async () => {
        await delay()
        let result = await this.HidCmdReadRam(this.addressList.norm_press_th.address, this.addressList.norm_press_th.length)
        let compareResult = arraysAreEqual(convertToBase10(result), this.keyNormPressList)
        if (compareResult) {
          this.getKeyNormPressData(result)
          this.submit_result3 = '1'
          return
        } else {
          times++
          if (times < 3) {
            await this.submitFastKeyValue()
          } else {
            this.submit_result3 = '2'
            return
          }
        }
      })
    },
    // 发送并校验快速触发模式下按键回弹距离的方法
    async submitFastKeyValue1() {
      let times = 0
      let arr = convertToArrayWithHighLowDigits(this.keyNormReturnList)
      await this.HidCmdSetRam(this.addressList.norm_return_th.address, arr, this.addressList.norm_return_th.length).then(async () => {
        await delay()
        let result = await this.HidCmdReadRam(this.addressList.norm_return_th.address, this.addressList.norm_return_th.length)
        let compareResult = arraysAreEqual(convertToBase10(result), this.keyNormReturnList)
        if (compareResult) {
          this.getKeyNormReturnDate(result)
          this.submit_result4 = '1'
          return
        } else {
          times++
          if (times < 3) {
            await this.submitFastKeyValue1()
          } else {
            this.submit_result4 = '2'
            return
          }
        }
      })
    },
    // 发送并校验快速触发模式下按键顶部死区的方法
    async submitFastKeyValue2() {
      let times = 0
      let arr = convertToArrayWithHighLowDigits(this.keyPressDeadzoneList)
      await this.HidCmdSetRam(this.addressList.press_deadzone.address, arr, this.addressList.press_deadzone.length).then(async () => {
        await delay()
        let result = await this.HidCmdReadRam(this.addressList.press_deadzone.address, this.addressList.press_deadzone.length)
        let compareResult = arraysAreEqual(convertToBase10(result), this.keyPressDeadzoneList)
        if (compareResult) {
          this.getKeyPressDeadDate(result)
          this.submit_result5 = '1'
          return
        } else {
          times++
          if (times < 3) {
            await this.submitFastKeyValue2()
          } else {
            this.submit_result5 = '2'
            return
          }
        }
      })
    },
    // 发送并校验快速触发模式下按键底部死区的方法
    async submitFastKeyValue3() {
      let times = 0
      let arr = convertToArrayWithHighLowDigits(this.keyReturnDeadzoneList)
      await this.HidCmdSetRam(this.addressList.return_deadzone.address, arr, this.addressList.return_deadzone.length).then(async () => {
        await delay()
        let result = await this.HidCmdReadRam(this.addressList.return_deadzone.address, this.addressList.return_deadzone.length)
        let compareResult = arraysAreEqual(convertToBase10(result), this.keyReturnDeadzoneList)
        if (compareResult) {
          this.getKeyReturnDeadDate(result)
          this.submit_result6 = '1'
          return
        } else {
          times++
          if (times < 3) {
            await this.submitFastKeyValue3()
          } else {
            this.submit_result6 = '2'
            return
          }
        }
      })
    },
    // 滑块滑动监听回调
    handleSliderChange(data) {
      this.keyObj = data
      let preRadio = null
      switch (this.keyObj.perRadio) {
        case '1':
          preRadio = 0 // 普通模式
          break;
        case '2':
          preRadio = 1 // 快速触发
          break;
      }
      if (this.checkedList.length !== 0) {
        if (['1','2'].includes(data.sign)) {
          for (let i = 0; i < this.checkedList.length; i++) {
            this.$set(this.keyModeList,this.checkedList[i],preRadio)
            this.$set(this.keyNormPressList,this.checkedList[i],this.keyObj.itinerary * 1000)
            this.$set(this.keyNormReturnList,this.checkedList[i],this.keyObj.resilience * 1000)
          }
        } else {
          for (let i = 0; i < this.checkedList.length; i++) {
            this.$set(this.keyModeList,this.checkedList[i],preRadio)
            this.$set(this.keyPressList,this.checkedList[i],this.keyObj.quickTrigger * 1000)
            this.$set(this.keyReturnList,this.checkedList[i],this.keyObj.quickResilience * 1000)
            this.$set(this.keyPressDeadzoneList,this.checkedList[i],this.keyObj.topDead * 1000)
            this.$set(this.keyReturnDeadzoneList,this.checkedList[i],this.keyObj.bottomDead * 1000)
          }
        }
        this.keyModeList = new Uint8Array([...this.keyModeList]);
      }
    },
    handleSettingTabChange(data) {
      this.keyObj = data
      this.functionMenu = data.perRadio
      if (this.checkedList.length) {
        if (data.perRadio === '0' || data.perRadio === '1') {
          for (let i = 0; i < this.checkedList.length; i++) {
            let a = this.checkedList[i]
            this.$set(this.keyModeList,a,Number(data.perRadio))
            // todo
            // this.$set(this.KeyResilientList,a,this.keyObj.resilience * 1000)
          }
          this.keyModeList = new Uint8Array([...this.keyModeList]);
        }
        // todo
        // this.getKeyProperty(this.propertyListCopy)
      }
    },
    // 功能模块切换
    handleNavActiveChange(obj) {
      this.tabNum = Number(obj.value)
      if (this.tabNum === 3) {
        // 监听键盘按下事件
        window.addEventListener("keydown", this.disableKeys);
      } else {
        // 切换页面时去除监听器
        window.removeEventListener("keydown", this.disableKeys);
      }
      switch (obj.value) {
        case '0':
          this.funPartCom = 'keysComponent'
          break;
        case '1':
          this.funPartCom = 'performanceSetting'
          break;
        case '2':
          this.funPartCom = 'lightingSetting'
          break;
        case '3':
          this.funPartCom = 'calibrateComponent'
          break;
        case '4':
          this.funPartCom = 'advancedKeysComponent'
          break;
      }
    },
    disableKeys(event) {
      // const key = event.key
      const isCtrl = event.ctrlKey || event.metaKey // Ctrl 键或 Command 键 (Mac)
      const isAlt = event.altKey
      const isShift = event.shiftKey

      // 禁用 F1 到 F12 等其他按键 的功能按键
      if ([123,122,121,120,119,118,117,116,115,114,113,112,9,13,32,8,16,17,18,27,20].includes(event.keyCode)) {
        event.preventDefault();
        event.stopPropagation();
        event.returnValue = false
        return false
      }

      // 禁用 Ctrl 组合键，例如 Ctrl+S, Ctrl+P, Ctrl+C 等
      if (isCtrl) {
        event.preventDefault();
        event.stopPropagation();
        event.returnValue = false
        return false
      }

      // 禁用 Alt 组合键，例如 Alt+Tab 等
      if (isAlt) {
        event.preventDefault();
        event.stopPropagation();
        event.returnValue = false
        return false
      }

      // 禁用 Shift 组合键，例如 Shift+Tab
      if (isShift) {
        event.preventDefault();
        event.stopPropagation();
        event.returnValue = false
        return false
      }
    },
    // 快速选择回调
    handleFastSelect(data) {
      if (data === '1') {
        if (this.tabNum === 1) {
          this.$set(this.keyStatusList,1,Array(this.keyboardLength).fill(true))
          this.checkedList = Array.from({ length: this.keyboardLength }, (v, k) => k)
          this.backDisplay()
        } else if (this.tabNum === 2) {
          this.$set(this.keyStatusList,2,Array(this.keyboardLength).fill(true))
          this.checkedListColor = Array.from({ length: this.keyboardLength }, (v, k) => k)
        }
      }
      if (data === '2') {
        let arr = []
        if (this.keyboardLength === 83) {
          arr = [32,46,47,48]
        }
        for (let i = 0; i < this.keyboardLength; i++) {
          if (arr.includes(i)) {
            this.$set(this.status, i, true)
          } else {
            this.$set(this.status, i, false)
          }
        }
        if (this.tabNum === 1) {
          this.checkedList = arr
          this.backDisplay()
        }
        if (this.tabNum === 2) {
          this.checkedListColor = arr
        }
      }
      if (data === '3') {
        let arr = []
        if (this.keyboardLength === 83) {
          arr = [16,17,18,19,20,21,22,23,24,25]
        }
        for (let i = 0; i < this.keyboardLength; i++) {
          if (arr.includes(i)) {
            this.$set(this.status, i, true)
          } else {
            this.$set(this.status, i, false)
          }
        }
        if (this.tabNum === 1) {
          this.checkedList = arr
          this.backDisplay()
        }
        if (this.tabNum === 2) {
          this.checkedListColor = arr
        }
      }
      if (data === '4') {
        let arr = []
        if (this.keyboardLength === 83) {
          arr = [31,32,33,34,35,36,37,38,39,40,46,47,48,49,50,51,52,53,54,60,61,62,63,64,65,66]
        }
        for (let i = 0; i < this.keyboardLength; i++) {
          if (arr.includes(i)) {
            this.$set(this.status, i, true)
          } else {
            this.$set(this.status, i, false)
          }
        }
        if (this.tabNum === 1) {
          this.checkedList = arr
          this.backDisplay()
        }
        if (this.tabNum === 2) {
          this.checkedListColor = arr
        }
      }
      if (data === '5') {
        if (this.tabNum === 1) {
          if (this.checkedList.length !== 0) {
            let list = []
            for (let i = 0; i < this.keyboardLength; i++) {
              if (this.checkedList.includes(i)) {
                this.$set(this.status, i, false)
              } else {
                this.$set(this.status, i, true)
                list.push(i)
              }
            }
            this.checkedList = list
            this.backDisplay()
          }
        }
        if (this.tabNum === 2) {
          if (this.checkedListColor.length !== 0) {
            let list = []
            for (let i = 0; i < this.keyboardLength; i++) {
              if (this.checkedListColor.includes(i)) {
                this.$set(this.status, i, false)
              } else {
                this.$set(this.status, i, true)
                list.push(i)
              }
            }
            this.checkedListColor = list
          }
        }
      }
      if (data === '6') {
        for (let i = 0; i < this.keyboardLength; i++) {
          this.$set(this.status, i, false)
          if (this.tabNum === 1) {
            this.checkedList = []
          }
          if (this.tabNum === 2) {
            this.checkedListColor = []
          }
        }
      }
    },
    // 层级切换
    layerChange(obj) {
      if (obj.value === '0') {
        this.layerBoxList[0].status = true
        this.layerBoxList[1].status = false
        this.isFnLayer = '0'
      } else {
        this.layerBoxList[0].status = false
        this.layerBoxList[1].status = true
        this.isFnLayer = '1'
      }
    },
    // 按键被点击
    async keyClick(i, status) {
      if (this.tabNum !== 3) {
        if (this.tabNum === 0) {
          this.$set(this.keyStatusList, 0, Array(this.keyboardLength).fill(false))
          this.$set(this.status, i, !status)
        } else if (this.tabNum === 4) {
          this.$set(this.keyStatusList, 4, Array(this.keyboardLength).fill(false))
          this.$set(this.status, i, !status)
          if (!status) {
            let address = '0x' + (Number(this.addressList.bind_key_setting.address) + i * 48).toString(16)
            let bindKeysValue = await this.HidCmdReadRam(address, this.addressList.bind_key_setting.length)
            EventBus.$emit('advancedKeyClick', {
              status: !status,
              index: i,
              bindKeysValue: bindKeysValue,
              bindKeyMode: this.bindKeyModeList[i]
            })
          }
        } else {
          this.$set(this.status, i, !status)
        }
        if (!status && this.tabNum === 1) {
          this.checkedList.push(i)
          this.backDisplay()
        } else if (status && this.tabNum === 1) {
          const index = this.checkedList.indexOf(i)
          if (index !== -1) {
            this.checkedList.splice(index, 1); // 删除数组中指定索引位置的元素
            this.backDisplay()
          }
        } else if (!status && this.tabNum === 2) {
          this.checkedListColor.push(i)
        } else if (status && this.tabNum === 2) {
          const index = this.checkedListColor.indexOf(i)
          if (index !== -1) {
            this.checkedListColor.splice(index, 1); // 删除数组中指定索引位置的元素
          }
        }
      } else if (this.tabNum === 3 && this.testMode === '1') { // 导航栏为测试，且测试模式为试轴器模式
        this.$set(this.keyStatusList, 3, Array(this.keyboardLength).fill(false))
        if (!status) {
          this.testKey = i
          this.$set(this.status, i, !status)
        } else {
          this.testKey = null
        }
        EventBus.$emit('testKeyChange', this.testKey)
      }
    },
    // 鼠标右键选择快速置空
    async handleRightClick(i, status) {
      if (this.tabNum === 0) {
        this.$set(this.keyStatusList,0,Array(this.keyboardLength).fill(false))
        this.$set(this.status, i, !status)

        let ram = [KeyCodes[''] & 0xff, KeyCodes[''] >> 8]

        let address = (this.isFnLayer === '0' ? ('0x' + (Number(this.addressList.key_map.address) + i * 2).toString(16)) : ('0x' + (Number(this.addressList.key_map_fn.address) + i * 2).toString(16)))
        let isComplete = await this.HidCmdSetRam(address, ram, 2)
        await delay()
        if (isComplete) {
          try {
            let arr = this.isFnLayer === '0' ? this.addressList.key_map.address : this.addressList.key_map_fn.address
            let newKeyMappingDate = await this.HidCmdReadRam(arr, this.addressList.key_map.length)
            this.getKeyMapping(newKeyMappingDate,this.isFnLayer)
          } catch (err) {
            console.log(err)
          }
        }

      } else if (this.tabNum === 4 && this.RearCoverStatus === '0') { // 高级按键为后覆盖
        this.$set(this.keyStatusList,4,Array(this.keyboardLength).fill(false))
        this.$set(this.status, i, !status)

        let ram = [KeyCodes[''] & 0xff, KeyCodes[''] >> 8]
        let address = '0x' + (Number(this.addressList.key_cancel_code.address) + i * 2).toString(16)
        let isComplete = await this.HidCmdSetRam(address, ram, 2)
        await delay()
        if (isComplete) {
          try {
            let newKeyMappingDate = await this.HidCmdReadRam(this.addressList.key_cancel_code.address, this.addressList.key_cancel_code.length)
            this.getRearCoverDate(newKeyMappingDate)
          } catch (err) {
            console.log(err)
          }
        }
      } else if (this.tabNum === 4 && this.RearCoverStatus === '1') { // 高级按键为组合键
        this.$set(this.keyStatusList,4,Array(this.keyboardLength).fill(false))
        this.$set(this.bindKeyModeList, i, 0)
        // this.$set(this.status, i, !status)
        let groupRam = convertToArrayWithHighLowDigits([1000,1000,1000,1000])
        let address = ('0x' + (Number(this.addressList.bind_key_setting.address) + i*48 + 16).toString(16))
        await this.HidCmdSetRam(this.addressList.bind_key_mode.address, this.bindKeyModeList, this.addressList.bind_key_mode.length)
        await delay()
        await this.HidCmdSetRam(address, groupRam, groupRam.length)
        await delay()
        let result = await this.HidCmdReadRam(this.addressList.bind_key_mode.address,this.addressList.bind_key_mode.length)
        this.getBindKeyModeData(result)
        EventBus.$emit('clearGroupKeys','1')
      } else if (this.tabNum === 4 && this.RearCoverStatus === '2') { // 高级按键为DKS
        this.$set(this.keyStatusList,4,Array(this.keyboardLength).fill(false))
        this.$set(this.bindKeyModeList, i, 0)
        let DKSRam = convertToArrayWithHighLowDigits([1000,1000,1000,1000])
        let address = ('0x' + (Number(this.addressList.bind_key_setting.address) + i*48 + 16).toString(16))
        await this.HidCmdSetRam(this.addressList.bind_key_mode.address, this.bindKeyModeList, this.addressList.bind_key_mode.length)
        await delay()
        await this.HidCmdSetRam(address, DKSRam, DKSRam.length)
        await delay()
        let result = await this.HidCmdReadRam(this.addressList.bind_key_mode.address,this.addressList.bind_key_mode.length)
        this.getBindKeyModeData(result)
        EventBus.$emit('clearGroupKeys','2')
      }
    },
    // 根据选中的按键反显下方滑块数值
    backDisplay() {
      let mode = ''
      let mode1 = '0'
      let list = []
      let list1 = []
      let body = []
      this.checkedList.forEach(item => {
        if (this.keyModeList[item] === 0) {
          mode = '1'
          list.push({
            trigger: this.keyNormPressList[item],
            resilient: this.keyNormReturnList[item]
          })
        } else if(this.keyModeList[item] === 1) {
          if (this.keyPressList[item] !== this.keyReturnList[item]) {
            mode1 = '1'
          }
          if (mode !== '1') mode = '2'
          list1.push({
            press: this.keyPressList[item],
            returnVal: this.keyReturnList[item],
            topPressDead: this.keyPressDeadzoneList[item],
            bottomPressDead: this.keyReturnDeadzoneList[item]
          })
        }
        body.push(this.keyBodyList[item])
      })
      EventBus.$emit('backDisplay',{
        functionMenu: this.functionMenu,
        mode: mode,
        mode1: mode1,
        list: list,
        list1: list1,
        body: body
      })
    },
    // 按键映射
    async handleChangeKey(val) {
      if (this.connected) {
        if (this.tabNum === 0) {
          let statusNum = 0
          let statusObj = this.keyStatusList[0]
          let num = null
          for (let i = 0; i < statusObj.length; i++) {
            if (statusObj[i]) {
              statusNum++
              num = i
              if (statusNum >= 2) {
                this.$notify({
                  title: this.$t('警告'),
                  message: this.$t('提示内容54'),
                  type: 'warning',
                  offset: 100
                })
                break
              }
            }
          }
          if (statusNum === 2) return
          let fixedKeys = []
          if (this.device.productId === 13694) { // zent75
            fixedKeys = [0,28,29,43,62,71,74,80,81,82]
          }
          if (fixedKeys.includes(num) && this.isFnLayer === '1') {
            this.$notify.info({
              title: this.$t('消息'),
              message: this.$t('提示内容55'),
              offset: 100
            });
            return
          }
          for (const item of statusObj) {
            const index = statusObj.indexOf(item);
            if (item) {
              let ram = [val & 0xff, val >> 8]
              let address = (this.isFnLayer === '0' ? ('0x' + (Number(this.addressList.key_map.address) + index * 2).toString(16)) : ('0x' + (Number(this.addressList.key_map_fn.address) + index * 2).toString(16)))
              let isComplete = await this.HidCmdSetRam(address, ram, 2)
              await delay()
              if (isComplete) {
                try {
                  let newKeyMappingDate = []
                  if (this.isFnLayer === '0') {
                    newKeyMappingDate = await this.HidCmdReadRam(this.addressList.key_map.address, this.addressList.key_map.length)
                  } else {
                    newKeyMappingDate = await this.HidCmdReadRam(this.addressList.key_map_fn.address, this.addressList.key_map_fn.length)
                  }
                  this.getKeyMapping(newKeyMappingDate,this.isFnLayer)
                  this.keyStatusList[0][index] = false
                } catch (err) {
                  console.log(err)
                }
              }
            }
          }
        } else if (this.tabNum === 4) {
          let statusNum = 0
          let statusObj = this.keyStatusList[4]
          for (let i = 0; i < statusObj.length; i++) {
            if (statusObj[i]) {
              statusNum++
              if (statusNum >= 2) {
                this.$notify({
                  title: this.$t('警告'),
                  message: this.$t('提示内容54'),
                  type: 'warning',
                  offset: 100
                })
                break
              }
            }
          }
          if (statusNum === 2) return
          for (const item of statusObj) {
            const index = statusObj.indexOf(item);
            if (item) {
              if (this.RearCoverStatus === '0') { // 高级按键为后覆盖
                let ram = [val & 0xff, val >> 8]
                let address = '0x' + (Number(this.addressList.key_cancel_code.address) + index * 2).toString(16)
                let isComplete = await this.HidCmdSetRam(address, ram, 2)
                await delay()
                if (isComplete) {
                  try {
                    let newKeyMappingDate = await this.HidCmdReadRam(this.addressList.key_cancel_code.address, this.addressList.key_cancel_code.length)
                    this.getRearCoverDate(newKeyMappingDate)
                    this.keyStatusList[0][index] = false
                  } catch (err) {
                    console.log(err)
                  }
                }
              }
            }
          }
        }
      }
    },
    async toggleHIDConnection(flag) {
      if(!flag) {
        await this.connectToDevice();
      } else {
        this.disconnectDevice();
        this.stopHeartbeat();
      }
    },
    // 获取已授权的特定hid设备
    async autoConnectDevice() {
      // 获取已经授权的hid设备
      const devices = await navigator.hid.getDevices();
      // 筛选特定设备
      let arr = []
      for (const e of devices) {
        const i = devices.indexOf(e);
        // 自动识别已授权的wob75、zent75、wob65
        if (e.vendorId === 0x36B0 && (e.productId === 13694) && e.collections[0].usagePage === 0xFF60 && e.collections[0].usage === 0x61) {
          arr.push({
            id: i,
            hidDev: e
          })
        }
      }
      this.$set(this,'deviceList',arr)
    },
    // 选择未授权的设备添加到设备数组当中
    async connectToDevice() {
      try {
        // Request access to HID devices
        const devices = await navigator.hid.requestDevice({filters: [{
            vendorId: 0x36B0,  // 根据VID进行过滤
            // productId: 0x352F, // 根据PID进行过滤  多个设备不传
            usagePage: 0xFF60,   // 根据usagePage进行过滤
            usage: 0x61,       // 根据usage进行过滤
          }]});
        if(devices && devices[0]) {
          const exists = this.deviceList.some(obj =>
            Object.keys(devices[0]).every(key => obj[key] === devices[0][key])
          )
          // 授权hid数组当中不存在该hid设备就插入，否则不做处理
          if (!exists) {
            if (devices[0].productId === 13694) {
              let length = this.deviceList.length
              this.deviceList.push({
                id: length,
                hidDev: devices[0]
              })
              // 第一次授权设备
              this.firstJoin = true
            }
          }
        }
      } catch (error) {
        console.error("Error connecting to HID device:", error);
      }
    },
    async getAllData() {
      try {
        // 读取配置名称
        const configNameList = await this.HidCmdReadRam(this.addressList.config_name1.address,this.addressList.config_name1.length * 4)
        EventBus.$emit('getConfigNameList',configNameList)

        // 读取按键映射数据(主层)
        const keyMappingDate = await this.HidCmdReadRam(this.addressList.key_map.address,this.addressList.key_map.length)
        this.getKeyMapping(keyMappingDate,'0')

        // 读取按键映射数据(fn层)
        const keyMappingDate_fn = await this.HidCmdReadRam(this.addressList.key_map_fn.address,this.addressList.key_map_fn.length)
        this.getKeyMapping(keyMappingDate_fn,'1')

        // 读取按键后覆盖数据
        const rearCoverDate = await this.HidCmdReadRam(this.addressList.key_cancel_code.address,this.addressList.key_cancel_code.length)
        this.getRearCoverDate(rearCoverDate)


        // 读取按键模式信息
        const keyModeDate = await this.HidCmdReadRam(this.addressList.key_mode.address,this.addressList.key_mode.length)
        this.getKeyMode(keyModeDate)

        // 读取按键触发距离
        const keyNormPressData = await this.HidCmdReadRam(this.addressList.norm_press_th.address,this.addressList.norm_press_th.length)
        this.getKeyNormPressData(keyNormPressData)

        // 读取按键回弹距离
        const keyNormReturnDate = await this.HidCmdReadRam(this.addressList.norm_return_th.address,this.addressList.norm_return_th.length)
        this.getKeyNormReturnDate(keyNormReturnDate)

        // 读取按键触发值rt
        const keyPressDate = await this.HidCmdReadRam(this.addressList.press_th.address,this.addressList.press_th.length)
        this.getKeyPressDate(keyPressDate)

        // 读取按键回弹值rt
        const keyReturnDate = await this.HidCmdReadRam(this.addressList.return_th.address,this.addressList.return_th.length)
        this.getKeyReturnDate(keyReturnDate)

        // 读取按键顶部死区
        const keyPressDeadDate = await this.HidCmdReadRam(this.addressList.press_deadzone.address,this.addressList.press_deadzone.length)
        this.getKeyPressDeadDate(keyPressDeadDate)

        // 读取按键底部死区
        const keyReturnDeadDate = await this.HidCmdReadRam(this.addressList.return_deadzone.address,this.addressList.return_deadzone.length)
        this.getKeyReturnDeadDate(keyReturnDeadDate)

        // 读取按键轴体
        const keyBodyType = await this.HidCmdReadRam(this.addressList.keytype_code.address,this.addressList.keytype_code.length)
        this.getKeyBodyTypeDate(keyBodyType)

        // 读取按键rgb数据
        const keyRGBDate = await this.HidCmdReadRam(this.addressList.rgb.address,this.addressList.rgb.length)
        const keyRGBModeDate = await this.HidCmdReadRam(this.addressList.rgb_solid_enable.address,this.addressList.rgb_solid_enable.length)
        this.getKeyRGBDate([...keyRGBDate,...keyRGBModeDate])

        // 读取键盘灯效数据
        const rgbSwitchData = await this.HidCmdReadRam(this.addressList.rgb_enable.address,10)
        // 传递键盘灯效数据给RGB组件
        EventBus.$emit('getRgbSwitchData',rgbSwitchData)

        // 读取键盘灯效数据
        const keyDynamicStateData = await this.HidCmdReadRam(this.addressList.rgb_config.address,this.addressList.rgb_config.length)
        // 传递键盘灯效数据给RGB组件
        EventBus.$emit('getKeyDynamicStateData',keyDynamicStateData)


        // 读取固件版本号
        if (this.firmwareVersion === '') {
          let result = await this.HidCmdReadRam(this.addressList.soft_version.address,this.addressList.soft_version.length)
          this.firmwareVersion = result[2] + '.' + result[1]+ '.' + result[0]
          this.version = (result[2] << 16) + (result[1] << 8) + result[0]
          EventBus.$emit('getFirmwareVersion',{
            firmwareVersion: this.firmwareVersion,
            version: this.version
          })
        }

        if (this.version >= 18) {
          // 读取组合键和DKS
          const bindKeyModeData = await this.HidCmdReadRam(this.addressList.bind_key_mode.address,this.addressList.bind_key_mode.length)
          this.getBindKeyModeData(bindKeyModeData)
        }

      } catch (error) {
        console.log(error)
      }
    },
    // 处理等到的厚覆盖按键数据
    getRearCoverDate(data) {
      this.rearCoverList = convertToBase10(data)
    },
    // 处理获取到的rgb数据
    getKeyRGBDate(data) {
      let arr1 = data.slice((this.keyboardLength+2)*3,(this.keyboardLength+2)*4) // 灯光模式
      let arr2 = data.slice(0,(this.keyboardLength + 2)*3)
      let arr3 = []
      let arr4 = []
      let arr5 = []
      for (let i = 0; i < (this.keyboardLength+2); i++) {
        let str = 'rgb(' + arr2[i * 3] + ',' + arr2[i * 3 + 1] + ',' + arr2[i * 3 + 2] + ')'
        arr4.push(str)
      }
      if (this.keyboardLength === 83) {
        for (let i = 0; i < colorCodes75_zent.length; i++) {
          if (i === 76) {
            arr3.push(arr1[colorCodes75_zent[i][1]])
            arr5.push(arr4[colorCodes75_zent[i][1]])
          } else {
            arr3.push(arr1[colorCodes75_zent[i]])
            arr5.push(arr4[colorCodes75_zent[i]])
          }
        }
      }
      this.RgbModeListCopy = arr3
      this.rgbList = arr5
    },
    // 处理获取到的按键轴体数据
    getKeyBodyTypeDate(data) {
      this.keyBodyList = convertToBase10(data)
    },
    // 处理获取到的按键底部死区数据
    getKeyReturnDeadDate(data) {
      this.keyReturnDeadzoneList = convertToBase10(data)
    },
    // 处理获取到的按键顶部死区数据
    getKeyPressDeadDate(data) {
      this.keyPressDeadzoneList = convertToBase10(data)
    },
    // 处理获取到的按键触发距离数据
    getKeyNormPressData(data) {
      this.keyNormPressList = convertToBase10(data)
    },
    // 处理获取到的按键回弹距离数据
    getKeyNormReturnDate(data) {
      this.keyNormReturnList = convertToBase10(data)
    },
    // 处理获取到的按键触发值数据
    getKeyReturnDate(data) {
      this.keyReturnList = convertToBase10(data)
    },
    // 处理获取到的按键回弹值数据
    getKeyPressDate(data) {
      this.keyPressList = convertToBase10(data)
    },
    // 获取高级按键的按键模式
    getBindKeyModeData(data) {
      this.bindKeyModeList = data
    },
    // 处理获取到的按键模式数据
    getKeyMode(data) {
      this.keyModeList = data
    },
    // 处理获取到的按键映射数据
    getKeyMapping(data,flag) {
      const result = convertToBase10(data)
      if (flag === '0') {
        this.$set(this.keyNameList,0,result)
      } else {
        this.$set(this.keyNameList,1,result)
      }
    },
    disconnectDevice() {
      // Close the device connection
      if (this.device) {
        // 去除监听器
        if (this.inputReportListener) {
          this.device.removeEventListener("inputreport", this.inputReportListener);
        }
        this.device.close();
        this.connected = false;
        // TODO 数据清除 this.clearData()
        EventBus.$emit('connected', false)
      }
    },
    stopHeartbeat() {
      if (this.intervalId !== null) {
        clearInterval(this.intervalId);
      }
    },
    handleHIDData(data) {
      // Process the received HID data
      this.hidData = data;
      let ack = this.ReceiveData(data);
      if(ack.length !== 0) {
        // console.log(`ReceiveData: ${ack}`);
        this.ack_buffer = ack;
      }
      if(data[0] === 0xbe && data[1] === 0xc0 && data[2] === 0x06 && data[3] === 0x00) {
        this.disposition = data[4]
      }
      if(data[0] === 0xbe && data[1] === 0x1d && data[2] === 0x15 && data[3] === 0x00) {
        // 序列号
        this.serialNumber = arrayToUint16StringArray(data.slice(4,20))
        EventBus.$emit('serialNumber',(this.serialNumber.join('') ? this.serialNumber.join('') : (!this.connected ? this.$t('提示内容1') : this.$t('提示内容57'))))
      }
      if(data[0] === 0xbe && data[1] === 0x03 && data[2] === 0x05 && data[3] === 0x00 && data[4] === 0xed) {
        this.sent_ack = true;
      }
      this.ReceiveKeyData(data);
    },
    sendHIDData() {
      while (!this.hid_send_buffer.isEmpty())
      {
        let data = this.hid_send_buffer.dequeue();
        this.device.sendReport(0, data)
      }
    },
    ReceiveData(Data){
      if(Data[0] !== 0xbe || (Data[1] !== 0x01 && Data[1] !== 0x04))
        return new Uint8Array(0);
      let length = Data[2] + Data[3] * 256;
      let crc16 = CRC16_Modbus(Data, length-3);
      let crc_data = Data[length - 2] * 256 + Data[length - 3];
      if(crc16 !== crc_data)
        return new Uint8Array(0);
      if(Data[length - 1] === 0xed) {
        let array = new Uint8Array(length-13);
        for(let i = 0; i < length-13; i++) {
          array[i] = Data[10 + i];
        }
        return array;
      }
      return new Uint8Array(0);
    },
    ReceiveKeyData(Data){
      let len = 0
      let len1 = 0
      let num = 0
      if (this.keyboardLength === 83) {
        len = 1017
        len1 = 1003
        num = 83
      }
      if(Data[0] !== 0xbe || Data[1] !== 0xfd)
        return;
      let length = Data[2] + Data[3] * 256;
      if(length === len && Data[length - 1] === 0xed) {
        let crc16 = CRC16_Modbus(Data, length-3);
        let crc_data = Data[length - 2] * 256 + Data[length - 3];
        if(crc16 !== crc_data)
          return;
        let data = new Uint16Array(num*2);
        for(let cnt = 2; cnt < num*2+2; cnt++) {
          data[cnt-2] = Data[cnt * 2] + Data[cnt * 2 + 1] * 256;
        }
        let arr1 = []
        let arr2 = []
        for(let cnt = 0; cnt < num; cnt++) {
          arr1.push(data[cnt])
          arr2.push((data[num+cnt] * 0.001))
        }
        this.$set(this, 'KeyValues', arr1)
        this.$set(this, 'KeyHeights', arr2)
      }
      if(length === len1 && Data[length - 1] === 0xed) {
        let crc16 = CRC16_Modbus(Data, length-3);
        let crc_data = Data[length - 2] * 256 + Data[length - 3];
        if(crc16 !== crc_data)
          return;
        let data = new Uint16Array(num*6);
        for(let cnt = 2; cnt < num*6+2; cnt++) {
          data[cnt-2] = Data[cnt * 2] + Data[cnt * 2 + 1] * 256;
        }
        let arr = []
        for(let cnt = 0; cnt < num; cnt++) {
          let avg = (data[cnt] + data[cnt+num] + data[cnt+num*2] + data[cnt+num*3] + data[cnt+num*4] + data[cnt+num*5]) / 6;
          arr.push(avg)
        }
        if (this.times % 2 === 0) {
          this.$set(this, 'KeyValues', arr)
        }
        this.handleKeyData({KeyValues: this.KeyValues})
      }
      // 试轴器  暂时去掉了
      // EventBus.$emit('keyData', {
      //   KeyValues: this.KeyValues,
      //   KeyHeights: this.KeyHeights
      // })
      // this.handleKeyData({KeyValues: this.KeyValues})
    },
    handleKeyData(data) {
      if (this.times === 0) {
        for (let i = 0; i < this.KeyDirection.length; i++) {
          if (data.KeyValues[i] > 32768) {
            this.KeyDirection[i] = '0'
          } else {
            this.KeyDirection[i] = '1'
          }
        }
      }
      this.times ++
      let newValue = data.KeyValues
      if (this.calStatus) {
        for (let i = 0; i < newValue.length; i++) {
          // 第一步判断只更新最大值或最小值
          if ((this.max[i] - this.min[i]) > 3000) {
            this.flag = 1
          }
          // 第二步根据轴体方向判断逻辑
          if (this.KeyDirection[i] === '0') { // 按下变大
            if(newValue[i] > this.max[i] ) {
              this.max[i] = Math.floor(newValue[i])
            }
            if (newValue[i] < this.min[i] &&  this.flag === 0) {
              this.min[i] = Math.floor(newValue[i])
            }
            let bodyValue = 0
            switch (this.keyBodyList[i]) {
              case 0:
                bodyValue = 7000
                break;
              case 1:
                bodyValue = 7000
                break;
              case 2:
                bodyValue = 7000
                break;
              case 3:
                bodyValue = 8000
                break;
            }
            if ((this.max[i] - this.min[i]) > bodyValue && this.times % 100 === 0) {
              this.calibrationStatus.splice(i,1,true)
              // 标记至少一个键完成了标定
              this.atLeastOne = true
            }
          } else { // 按下变小
            if(newValue[i] > this.max[i] &&  this.flag === 0) {
              this.max[i] = Math.floor(newValue[i])
            }
            if (newValue[i] < this.min[i]) {
              this.min[i] = Math.floor(newValue[i])
            }
            let bodyValue = 0
            switch (this.keyBodyList[i]) {
              case 0:
                bodyValue = 7000
                break;
              case 1:
                bodyValue = 7000
                break;
              case 2:
                bodyValue = 7000
                break;
              case 3:
                bodyValue = 8000
                break;
            }
            if ((this.max[i] - this.min[i]) > bodyValue && this.times % 100 === 0) {
              this.calibrationStatus.splice(i,1,true)
              this.atLeastOne = true
            }
          }
        }
        if (this.times % 20 === 0) {
          this.$set(this.keyStatusList, 3, this.calibrationStatus)
          // this.$set(this,'status',this.calibrationStatus)
        }
        // if (this.times % 20 === 0) {
        //   this.$set(this, 'KeyValues', data.KeyValues)
        // }
      }
    },
    async HidCmdReadRam(addr, Length){
      if (!this.device) {
        return
      }
      let array = new Uint8Array([0xbe, 0x04, 11, 0, addr & 0xff, (addr >> 8) & 0xff, (addr >> 16) & 0xff, addr >> 24, Length >> 8, Length & 0xff, 0xed]);

      while(this.sent_state) {
        await new Promise((resolve => setTimeout(resolve,10)))
      }
      this.sent_state = true

      let receive_cnt = 0;
      this.ack_buffer = new Uint8Array(0);
      this.HidPushSendQueue(array, array.length);
      while(this.ack_buffer.length === 0 && receive_cnt < 5) {
        await new Promise(resolve => setTimeout(resolve, 10));
        receive_cnt += 1;
      }
      if(this.ack_buffer.length === 0) {
        if (this.readErrorNum === 0) {
          this.$notify.error({
            title: this.$t('错误'),
            message: this.$t('提示内容58')
          });
        }
        this.readErrorNum++
      }
      // console.log('111',this.ack_buffer);
      // console.log('测试读',addr, Length,this.ack_buffer)
      this.sent_state = false
      return this.ack_buffer;
    },
    async HidCmdSetRam(addr, ram, Length){
      if (!this.device) {return;}
      let receive_cnt = 0;
      let array = new Uint8Array(1024);
      let head = new Uint8Array([0xbe, 0x03, (13+Length) & 0xff, (13+Length) >> 8, addr & 0xff, (addr >> 8) & 0xff, (addr >> 16) & 0xff, addr >> 24, Length >> 8, Length & 0xff, 0xed]);

      for (let i = 0; i < 10; i++) array[i] = head[i];
      for (let i = 0; i < Length; i++) array[i + 10] = ram[i];

      let crc16 = CRC16_Modbus(array, Length + 10);
      array[Length + 10] = crc16 & 0xff;
      array[Length + 11] = crc16 >> 8;
      array[Length + 12] = 0xed;

      while(this.sent_state) {
        await new Promise((resolve => setTimeout(resolve,10)))
      }
      this.sent_state = true

      this.sent_ack = false;
      this.hid_send_buffer.enqueue(array);
      while(!this.sent_ack && receive_cnt < 15) {
        await new Promise(resolve => setTimeout(resolve, 10));
        receive_cnt += 1;
      }
      if(!this.sent_ack) {
        console.log(`ram mopdify no ack`);
        return false;
      }
      this.sent_state = false
      return true;
    },
    HidPushSendQueue(Buffer, Length){
      if (!this.device) {
        return;
      }
      const outputData = new Uint8Array(1024); // 要发送的数据包
      for (let i = 0; i < Length; i++) {
        outputData[i] = Buffer[i];
        // console.log('outputData',outputData)
      }
      // console.log('this.hid_send_buffer.enqueue',this.hid_send_buffer.enqueue)
      this.hid_send_buffer.enqueue(outputData);
    },
    async HidCmdReadFlash(addr, Length){
      if (!this.device) {return;}
      let array = new Uint8Array([0xbe, 0x01, 11, 0, addr & 0xff, (addr >> 8) & 0xff, (addr >> 16) & 0xff, addr >> 24, Length >> 8, Length & 0xff, 0xed]);

      while(this.sent_state) {
        await new Promise((resolve => setTimeout(resolve,10)))
      }
      this.sent_state = true

      let receive_cnt = 0;
      this.ack_buffer = new Uint8Array(0);
      this.HidPushSendQueue(array, array.length);
      while(this.ack_buffer.length == 0 && receive_cnt < 5) {
        await new Promise(resolve => setTimeout(resolve, 10));
        receive_cnt += 1;
      }
      if(this.ack_buffer.length == 0) {
        // console.log(`ram read no ack`);
      }
      this.sent_state = false
      return this.ack_buffer;
    },
    sendHeartReport() {
      const heartReportData = new Uint8Array([0xbe, 0x00, 0x05, 0x00, 0xed]);
      this.HidPushSendQueue(heartReportData, 5);
    },
    HidCmdCalib(calib_enable) {
      const heartReportData = new Uint8Array([0xbe, 0xfe, 0x06, 0x00, calib_enable, 0xed]);
      this.HidPushSendQueue(heartReportData, 6);
    },
    // 读取序列号
    HidCmdSerialNumber() {
      if (this.connected) {
        const heartReportData = new Uint8Array([0xbe, 0x1d, 0x05, 0x00, 0xed]);
        this.HidPushSendQueue(heartReportData, 5);
      }
    },
    async HidCmdDownload() {
      if (this.connected) {
        const heartReportData = new Uint8Array([0xbe, 0xfc, 0x05, 0x00, 0xed]);
        this.HidPushSendQueue(heartReportData, 5);
        await delay(500)
        this.connected = false
        EventBus.$emit('downloadModeResult', true)
      } else {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容1'),
          offset: 100
        })
        EventBus.$emit('downloadModeResult', false)
      }
    },
    async HidCmdSave() {
      if (this.connected) {
        const heartReportData = new Uint8Array([0xbe, 0x02, 0x05, 0x00, 0xed]);
        this.HidPushSendQueue(heartReportData, 5);
        await delay(1100)
        // 允许点击确认修改
        this.Saving = false
        // 去除选中的性能模式的按键
        // this.$set(this.keyStatusList,1,Array(this.keyboardLength).fill(false))
        // this.checkedList = []

        this.$notify({
          title: this.$t('成功'),
          message: this.$t('提示内容59'),
          type: 'success',
          offset: 100
        })
      } else {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容1'),
          offset: 100
        })
      }
    },
    HidCmdResetConfig() {
      if (this.connected) {
        const heartReportData = new Uint8Array([0xbe, 0xee, 0x05, 0x00, 0xed]);
        this.HidPushSendQueue(heartReportData, 5);
      } else {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容1'),
          offset: 100
        })
      }
    },
    HidCmdSwitchConfig(config_num) {
      const heartReportData = new Uint8Array([0xbe, 0xc0, 0x06, 0x00, config_num, 0xed]);
      this.HidPushSendQueue(heartReportData, 6);
    },
    startHeartbeat() {
      // Start sending heart reports every second
      this.intervalId = setInterval(() => {
        this.sendHeartReport();
      }, 1000)
      // this.receive_monitor_task = setInterval(() => {
      //   this.receive_monitor = this.receive_monitor_cnt;
      //   this.receive_monitor_cnt = 0;
      //   if(this.receive_monitor == 0) {
      //     console.log("receive no msgs for 1s")
      //     if(document.visibilityState != 'hidden') {
      //       console.log("visable but no msgs")
      //       this.sendHeartReport();
      //       this.sendHIDData();
      //     }
      //   }
      // }, 1000);
    },
    async HidCmdReset() {
      if (this.connected) {
        if (this.HidCmdReset) {
          // Create a Uint8Array representing the heart report data
          const heartReportData = new Uint8Array([0xbe, 0xff, 0x05, 0x00, 0xed]);
          this.HidPushSendQueue(heartReportData, 5);
          await new Promise(resolve => setTimeout(resolve, 1000));
          this.connected = false
          await this.toggleHIDConnection(true);
        }
      } else {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容1'),
          offset: 100
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
  #keyboardPart {
    //display: flex;
    //flex-direction: column;
    width: 100%;
    height: 100%;
    border-radius: 0.1rem;
    padding: 0.1rem;
    //@include background_color('background_color_sidebar');
    @include font_color('font_color');
    .head {
      display: flex;
      .title,.el-button  {
        font-weight: 700;
        margin-right: 1rem;
        font-size: 0.16rem;
      }
    }
    // 连接按钮盒子
    .connectBox {
      height: 30%;
      display: flex;
      justify-content: center;
      align-items: center;
      .link {
        overflow: hidden;
        padding: 3vmin;
        border-radius: 0.05rem;
        font-size: 0.2rem;
        box-shadow: 0 0.1rem 0.2rem rgba(0,0,0,0.3);

        position: relative;
        z-index: 0;
      }

      .link::before {
        content: '';
        width: 200%;
        height: 300%;
        @include background_color('background_color_sidebar');
        background-image: conic-gradient(
          transparent, #409EFF, transparent 30%
        );
        position: absolute;
        left: -50%;
        top: -100%;
        z-index: -2;
        animation: rotate 5s linear infinite;
      }

      .link::after {
        content: '';
        inset: 0.5vmin;
        position: absolute;
        z-index: -1;
        @include background_color('background_color_main');
        border-radius: 0.04rem;
      }

      .link:hover::after {
        @include background_color('background_color_main1');
      }

      @keyframes rotate {
        100% {
          transform: rotate(360deg);
        }
      }
    }
    // 信息盒子
    .content {
      height: 3rem;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      transition: all 0.5s;
      .keyboardBox_out {
        width: 4.5rem;
        height: 100%;
        border-radius: 0.2rem;
        @include background_color('background_color_sidebar');
        box-shadow: 0 0.05rem 0.12rem rgba(0,0,0,0.5);
        transition: all 0.5s;
        .keyboardBox {
          width: 100%;
          height: 100%;
          border-radius: 0.15rem;
          @include background_color('background_color_sidebar');
          .keyboardName {
            height: 0.5rem;
            line-height: 0.5rem;
            text-align: center;
            font-size: 0.2rem;
            font-weight: 700;
          }
          .keyboardImg {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 60%;
            .keyboardImgIn {
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .keyboardStatus {
            height: calc(40% - 0.5rem);
            background-color: #409EFF;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            border-radius: 0 0 0.15rem 0.15rem;
            p {
              height: 100%;
              color: white;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.2rem;
            }
          }
        }
      }
      .keyboardBox_out:hover {
        transform: translateY(-0.08rem) scale(1.01,1.01);
        box-shadow: 0 0.1rem 0.2rem rgba(0,0,0,0.3);
      }
    }
    // 键盘盒子
    .centralRegion {
      display: flex;
      justify-content: center;
      .keyBoxs_border {
        display: inline-block;
        padding: 0.1rem;
        border-radius: 0.1rem;
        @include background_color('background_color_main');
        @include border_color('background_color_sidebar');
        border: 0.1rem solid;
        margin-left: 0.2rem;
        margin-top: 0.3rem;
        .keyBoxs {
          display: flex;
          width: 9.6rem;
          flex-wrap: wrap;
          align-items: center;
          .keyBoxOut {
            width: 0.6rem;
            height: 0.6rem;
            padding: 0.01rem;
            box-sizing: border-box;
            border-radius: 0.05rem;
            user-select: none; /* 禁止文字被选中 */
            .selectOut {
              height: 100%;
              .keyBox {
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                //background-color: #fff;
                border-radius: 0.03rem;
                border-width: 0.04rem 0.09rem 0.12rem 0.06rem !important;
                @include border-top-color('border-top-color');
                @include border-right-color('border-right-color');
                @include border-bottom-color('border-bottom-color');
                @include border-left-color('border-left-color');
                border: solid;
                .keyBoxIn {
                  position: relative;
                  width: 100%;
                  height: 100%;
                  font-size: 0.12rem;
                  font-weight: 700;
                  @include background_color('background_color_key');
                  white-space: normal; /* 允许文字换行 */
                  word-wrap: break-word; /* 换行时在单词内部断开 */
                  overflow-wrap: break-word; /* 与word-wrap一起使用，以便在边界处换行 */
                  .cover {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    color: #409eff;
                  }
                  .groups {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: inline-flex;
                    justify-content: center;
                    align-items: end;
                    .group {
                      text-align: center;
                      width: 0.3rem;
                      font-size: 0.1rem;
                      padding: 0.02rem;
                      line-height: 0.1rem;
                      color: #ffffff;
                      border-radius: 0.02rem;
                      background-color: #409eff;
                      margin-bottom: 0.1rem;
                    }
                  }
                  .modeBox {
                    position: relative;
                    .fastBox {
                      display: flex;
                      justify-content: space-between;
                      .fast {
                        font-size: 0.09rem;
                        line-height: 0.12rem;
                      }
                    }
                    .keyBody {
                      height: 100%;
                      display: flex;
                      justify-content: center;
                      .bodyBox {
                        display: inline-block;
                        height: 100%;
                        padding: 0.03rem;
                        text-align: center;
                        line-height: 1;
                        border-radius: 0.05rem;
                        color: #333333;
                      }
                      .bgc {
                        background-color: #ffd200;
                      }
                      .bgc1 {
                        background-color: #de858e;
                      }
                      .bgc2 {
                        background-color: #F1DEC6;
                      }
                      .bgc3 {
                        background-color: #F65060FF;
                      }
                    }
                    .press {
                      font-size: 0.08rem !important;
                    }
                    .rgbBox {
                      width: 0.2rem;
                      height: 0.2rem;
                      border-radius: 0.1rem;
                      line-height: 0.2rem;
                      text-align: center;
                      background-color: #888888;
                      color: #f1eeee;
                    }
                    .warn {
                      color: #ff8000;
                    }
                  }
                  .recoverBox {
                    position: absolute;
                    right: -0.05rem;
                    bottom: -0.05rem;
                    width: 0.2rem;
                    height: 0.2rem;
                    line-height: 0.2rem;
                    border-radius: 50%;
                    text-align: -webkit-center;
                    color: white;
                    font-size: 0.12rem;
                    background-color: #13ce66;
                  }
                }
              }
            }
            .selected {
              border: 0.03rem solid !important;
              border-radius: 0.05rem;
              @include border_color('border_color_key_select');
              .modeBox {
                font-size: 0.1rem;
                .rgbBox {
                  font-size: 0.12rem;
                }
              }
            }
          }
          .keyBoxOut:hover {
            padding: 0.03rem;
          }
          .keyBig1 {
            width: 1.2rem !important;
          }
          .keyBig2 {
            width: 0.9rem !important;
          }
          .keyBig3 {
            width: 1.05rem !important;
          }
          .keyBig4 {
            width: 1.35rem !important;
          }
          .keyBig5 {
            width: 0.75rem!important;
          }
          .keyBig6 {
            width: 3.75rem !important;
          }
          .interval1 {
            margin-right: 0.15rem;
            margin-bottom: 0.15rem;
          }
          .interval2 {
            margin-right: 0.6rem;
          }
          .interval3 {
            margin-right: 0.3rem;
          }
          .interval4 {
            margin-bottom: 0.15rem;
          }
        }
      }
    }
    // 按键区域盒子
    .layerBox {
      display: flex;
      justify-content: center;
      height: 1rem;
      position: relative;
      .layerBoxItem {
        display: flex;
        align-items: center;
        .layer {
          width: 1rem;
          height: 0.4rem;
          line-height: 0.4rem;
          text-align: center;
          border-radius: 0.2rem;
          font-size: 0.16rem;
          @include background_color('background_color_sidebar');
          @include font_color('font_color')
        }
        .layer:first-child {
          margin-right: 0.2rem;
        }
        .layerActive.layer {
          background-color: #409EFF !important;
          @include font_color('font_color_active')
        }
        .el-button {
          height: 0.4rem;
          border-width: 0.01rem;
          padding: 0.12rem 0.2rem;
          font-size: 0.14rem;
          border-radius: 0.04rem;
        }
        .buttonBox {
          margin-left: 0.2rem;
          .el-button {
            font-size: 0.14rem;
            padding: 0.12rem 0.2rem;
            border-radius: 0.04rem;
          }
        }
      }
      .right {
        position: absolute;
        top: 0.3rem;
        right: 0.2rem;
      }
    }
    .confirmBox {
      display: flex;
      justify-content: center;
      margin: 1rem 0 0.2rem 0;
    }
    .hidden {
      visibility: hidden;
    }
    // 下方功能区域
    .funPart {
      width: 100%;
      min-height: 45vh;
      overflow: hidden;
      margin-top: 0.2rem;
      @include background_color('background_color_sidebar');
      border-radius: 0.2rem;
    }
  }
</style>
